$("a.card-anchor").on("focus", function () {
  $(this).closest(".card__media").css({
    outline: "0.2rem solid rgba(var(--color-foreground),0.5)",
    "box-shadow": "1px 1px 1px 1px black, 1px 1px 0.5rem 0.4rem black",
  });

  $(this).closest(".card__inner").css({
    outline: "0.2rem solid rgba(var(--color-foreground),0.5)",
    "box-shadow": "1px 1px 1px 1px black, 1px 1px 0.5rem 0.4rem black",
  });
});

$("a.card-anchor").on("blur", function () {
  $(this).closest(".card__media").css({
    outline: "none",
    "box-shadow": "unset",
  });

  $(this).closest(".card__inner").css({
    outline: "none",
    "box-shadow": "unset",
  });
});

// play pause videos functionality
let videos = Array.from(document.querySelectorAll("video"));
/**
 *  for each video
 * - set an id
 * - add a button with styles
 * - add event listener for that button
 */
for (let i = 0; i < videos.length; i++) {
  videos[i].id = `id-video-${i + 1}`;
  // only add controls if they have atleast one source video child
  if (videos[i].children.length) {
    addVideoControl(videos[i], i);
  }
}

/**
 * this method adds video control
 */
function addVideoControl(videoNode, i) {
  var button = document.createElement("button");
  button.classList.add("playback-control", "video-button");
  button.id = `id-video-control-${i}`;
  button.innerHTML = "| |";
  button.setAttribute("role", "button");
  button.setAttribute("tabindex", "0");
  button.setAttribute("aria-label", "Pause button");
  button.style.position = "absolute";
  button.style.width = "30px";
  button.style.height = "30px";
  videoNode.parentNode.insertBefore(button, videoNode.nextSibling);
  button.addEventListener("click", function (e) {
    if (videoNode.paused) {
      videoNode.play();
      button.innerHTML = "| |";
      button.setAttribute("aria-label", "Pause Video");
    } else {
      videoNode.pause();
      button.innerHTML = "▶";
      button.setAttribute("aria-label", "Play Video");
    }
  });
}

/**
 ** functionality to swap the position of cards
 */

// this function position of 2 nodes
const swap = function (nodeA, nodeB) {
  const parentA = nodeA.parentNode;
  const siblingA = nodeA.nextSibling === nodeB ? nodeA : nodeA.nextSibling;

  // Move `nodeA` to before the `nodeB`
  nodeB.parentNode.insertBefore(nodeA, nodeB);

  // Move `nodeB` to before the sibling of `nodeA`
  parentA.insertBefore(nodeB, siblingA);
};

Array.from(document.querySelectorAll(".card-wrapper")).forEach(
  (card, index) => {
    (window.matchMedia("(min-width: 750px)").matches
      ? index % 4 > 1
      : index % 2 > 0) && swap(card.children[0], card.children[1]);
  }
);

// shoot a custom event
function shootCartChangeEvent(details) {
  let event = new CustomEvent("Cart-change", {
    detail: details,
  });
  document.dispatchEvent(event);
}

// Track any update in cart and call custom event to add additional functionality
(function (ns, fetch) {
  ns.fetch = function () {
    let response = fetch.apply(this, arguments);
    response.then((res) => {
      if (
        [
          `${window.location.origin}/cart/add`,
          `${window.location.origin}/cart/update`,
          `${window.location.origin}/cart/change`,
          `${window.location.origin}/cart/clear`,
        ].includes(res.url)
      ) {
        shootCartChangeEvent({ self: this, arguments: arguments });
      }
    });
    return response;
  };
})(window, window.fetch);

// progress bar in cart with sock promotion

function updateProgressBar() {
 
  const freeShippingThreshold = Math.ceil(
    parseFloat(Shopify.currency.rate) *
      (typeof window.shippingThreshold !== "undefined"
        ? window.shippingThreshold
        : 5000)
  );

  // 50 USD
  // get cart
  if (freeShippingThreshold <= 0 ) {
	$(".Cart-progress-line").css("width", "100%");
	$(".Cart-progress-text").text("Free Shipping Unlocked.");
  } else {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((result) => {
        // if no items in cart. remove message and progressbar
        if (result.items_subtotal_price === 0) {
          setTimeout(() => {
            let freeShippingAt = Math.floor(
              (freeShippingThreshold / 100).toFixed(2)
            );
            $(".Cart-progress-line").css("width", "0");
            $(".Cart-progress-line").addClass("ge-hide");
            $(".Cart-progress-text").text(
              `Spend ${Shopify.country}$ ${freeShippingAt} for Free Shipping.`
            );
          }, 2000);
          return;
        }

        // if gift is in cart

        if (result.items_subtotal_price < freeShippingThreshold) {
          setTimeout(() => {
            let width = Math.ceil(
              (result.items_subtotal_price / freeShippingThreshold) * 100
            );
            let freeShippingAt = Math.floor(
              (
                (freeShippingThreshold - result.items_subtotal_price) /
                100
              ).toFixed(2)
            );
            $(".Cart-progress-line").css("width", `${width}%`);
            $(".Cart-progress-line").addClass("ge-hide");
            $(".Cart-progress-text").text(
              `Spend ${Shopify.country}$ ${freeShippingAt} for Free Shipping.`
            );
          }, 2000);
        } else if (result.items_subtotal_price >= freeShippingThreshold) {
          setTimeout(() => {
            $(".Cart-progress-line").css("width", "100%");
            $(".Cart-progress-text").text("Free Shipping Unlocked.");
          }, 2000);
        }
      });
  }
}

document.addEventListener("Cart-change", (e) => {
  // update progress bar
  updateProgressBar();
});

updateProgressBar();
